import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Result } from 'antd';
import { useAdminScope } from '../../context/AdminScopeContext';

/** 平台管理员或至少管理一个租户的用户可访问管理功能 */
export function ManagementAccessRoutes() {
  const { scope } = useAdminScope();
  const navigate = useNavigate();
  const allowed = Boolean(scope?.canAccessDcAdmin);

  useEffect(() => {
    if (scope && !scope.canAccessDcAdmin) {
      navigate('/forbidden', { replace: true });
    }
  }, [scope, navigate]);

  if (!scope || !allowed) {
    return null;
  }

  return <Outlet />;
}

/** 仅平台管理员（JWT realm/client role） */
export function PlatformAdminOnlyRoutes() {
  const { scope } = useAdminScope();
  const navigate = useNavigate();
  const allowed = Boolean(scope?.isPlatformAdmin);

  useEffect(() => {
    if (scope && !scope.isPlatformAdmin) {
      navigate('/forbidden', { replace: true });
    }
  }, [scope, navigate]);

  if (!scope || !allowed) {
    return null;
  }

  return <Outlet />;
}

export function ForbiddenPage() {
  const { scope } = useAdminScope();

  const subTitle = scope?.canAccessDcAdmin
    ? '当前页面仅平台管理员可访问。'
    : '需要平台管理员（Keycloak admin / realm-admin），或被指定为组织租户（ORGANIZATION）的管理员。个人租户用户无法使用本系统。';

  return (
    <Result
      status="403"
      title="无访问权限"
      subTitle={subTitle}
    />
  );
}
